import { render, staticRenderFns } from "./tevkifat.vue?vue&type=template&id=791af586&"
import script from "./tevkifat.vue?vue&type=script&lang=js&"
export * from "./tevkifat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports